import { render } from "./TableWithTabs.vue?vue&type=template&id=1ff3f584&scoped=true&ts=true"
import script from "./TableWithTabs.vue?vue&type=script&lang=ts"
export * from "./TableWithTabs.vue?vue&type=script&lang=ts"

import "./TableWithTabs.vue?vue&type=style&index=0&id=1ff3f584&lang=scss&scoped=true"

import exportComponent from "E:\\workspace13\\aries-backend-front\\kailas-aries\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_64f3209c872a893711b3e776f2c9ff1e\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff3f584"]])

export default __exports__